import { render } from "./NotificationSettingsEmailPreferences.vue?vue&type=template&id=4abcce56"
import script from "./NotificationSettingsEmailPreferences.vue?vue&type=script&lang=js"
export * from "./NotificationSettingsEmailPreferences.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__